import React from 'react';
import ContactForm from './ContactForm';

import Bg from '../assets/contact.jpg';

const Contact = () => {
  return (
    <div className="relative min-h-screen flex flex-col">
      <div 
        className="absolute inset-0 bg-cover bg-center" 
        style={{ 
          backgroundImage: `url(${Bg})`, 
          
        }}
      />
      <div className="relative z-10">
    
        <div className="flex-grow flex items-center md:mt-24 justify-center p-6">
          <div className="bg-white text-gray-600 shadow-lg rounded-lg w-full max-w-4xl p-6">
            <div className="md:flex">
              <div className="md:w-1/3 p-6">
                <h2 className="text-2xl font-semibold text-[#104D7B]">We're Here to Help</h2>
                <p className="mt-4 text-gray-600">We're dedicated to enhancing your experience every step of the way. Need assistance or have questions? We've got you covered. Reach out, and we'll be there to help!</p>
                <button className="mt-6 px-4 py-2 bg-[#005A9A] text-white rounded"><a href="./"> Learn More About Us</a></button>
                <div className="mt-6">
                  <h3 className="font-semibold text-gray-600">General Inquiries</h3>
                  <p className="text-gray-600">Email: info@hospitality.com</p>
                  <p className="text-gray-600">Phone: (123) 456-7890</p>
                </div>
                <div className="mt-6">
                  <h3 className="font-semibold text-gray-600">Customer Support</h3>
                  <p className="text-gray-600">For immediate assistance, please contact our support team.</p>
                  <a href="mailto:support@hospitality.com" className="text-[#104D7B] underline">support@hospitality.com</a>
                </div>
              </div>
              <div className="md:w-2/3 p-6 bg-gray-50 rounded-lg">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
